import useCommonStore from "@/stores/common.js";
import useUserStore from './user';

export default function useStore() {
  return {
    commonStore: useCommonStore(),
    userStore: useUserStore(),
  }
}
